import { __assign } from 'tslib';
import React__default, { createContext, useMemo } from 'react';

var TextCopyContext = createContext({});
var TextCopyContextProvider = function (_a) {
    var children = _a.children, source = _a.source;
    var flatTextCopies = function (textCopies) {
        return textCopies.reduce(function (acc, _a) {
            var _b;
            var _c;
            var _d = _a.fields, copy = _d.copy, key = _d.key, media = _d.media;
            var textOrMedia = copy || ((_c = media === null || media === void 0 ? void 0 : media.fields) === null || _c === void 0 ? void 0 : _c.imageOrVideo);
            if (!textOrMedia)
                return acc;
            return __assign(__assign({}, acc), (_b = {}, _b["".concat(key)] = textOrMedia, _b));
        }, {});
    };
    var filteredTextCopies = useMemo(function () {
        var _a, _b;
        return ((_a = source === null || source === void 0 ? void 0 : source.fields) === null || _a === void 0 ? void 0 : _a.textCopies) ? flatTextCopies((_b = source === null || source === void 0 ? void 0 : source.fields) === null || _b === void 0 ? void 0 : _b.textCopies) : {};
    }, [source]);
    var getComponentProps = function () {
        var _a, _b, _c, _d;
        var componentType = (_c = (_b = (_a = source === null || source === void 0 ? void 0 : source.sys) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.sys) === null || _c === void 0 ? void 0 : _c.id;
        var componentName = componentType === 'componentBlock' ? (_d = source === null || source === void 0 ? void 0 : source.fields) === null || _d === void 0 ? void 0 : _d.componentName : componentType;
        return {
            componentName: componentName,
            componentType: componentType,
        };
    };
    var _b = getComponentProps(), componentName = _b.componentName, componentType = _b.componentType;
    var defaultComponentValues = useMemo(function () { return ({
        componentMedias: {},
        componentTexts: {},
    }); }, []);
    var _c = useMemo(function () {
        var keys = Object.keys(filteredTextCopies);
        if (!keys.length)
            return defaultComponentValues;
        return keys.reduce(function (acc, keyword) {
            var _a, _b, _c;
            var _d, _e, _f, _g, _h;
            if (typeof filteredTextCopies[keyword] === 'object') {
                var imageOrVideo = filteredTextCopies[keyword];
                var isImage = imageOrVideo.sys.contentType.sys.id === 'image';
                var vimeoVideo = (_d = imageOrVideo === null || imageOrVideo === void 0 ? void 0 : imageOrVideo.fields) === null || _d === void 0 ? void 0 : _d.vimeoId;
                return __assign(__assign({}, acc), { componentMedias: __assign(__assign({}, acc.componentMedias), (_a = {}, _a[keyword] = imageOrVideo, _a)), componentTexts: __assign(__assign({}, acc.componentTexts), (_b = {}, _b[keyword] = isImage
                        ? (_e = imageOrVideo === null || imageOrVideo === void 0 ? void 0 : imageOrVideo.fields) === null || _e === void 0 ? void 0 : _e.asset.fields.file.url
                        : vimeoVideo !== null && vimeoVideo !== void 0 ? vimeoVideo : (_h = (_g = (_f = imageOrVideo === null || imageOrVideo === void 0 ? void 0 : imageOrVideo.fields) === null || _f === void 0 ? void 0 : _f.asset) === null || _g === void 0 ? void 0 : _g.fields) === null || _h === void 0 ? void 0 : _h.file.url, _b)) });
            }
            return __assign(__assign({}, acc), { componentTexts: __assign(__assign({}, acc.componentTexts), (_c = {}, _c[keyword] = filteredTextCopies[keyword], _c)) });
        }, defaultComponentValues);
    }, [filteredTextCopies, defaultComponentValues]), componentTexts = _c.componentTexts, componentMedias = _c.componentMedias;
    return (React__default.createElement(TextCopyContext.Provider, { value: {
            componentMedias: componentMedias,
            componentName: componentName,
            componentTexts: componentTexts,
            componentType: componentType,
        } }, children));
};

export { TextCopyContext, TextCopyContextProvider };
//# sourceMappingURL=TextCopyContext.esm.js.map
